 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import PROJECTKEEPSAKE59 from '@/components/ProjectKeepsake59'
 import PROJECTKEEPSAKE60 from '@/components/ProjectKeepsake60'
 import PROJECTKEEPSAKE61 from '@/components/ProjectKeepsake61'
 import PROJECTKEEPSAKE62 from '@/components/ProjectKeepsake62'
 import PROJECTKEEPSAKE63 from '@/components/ProjectKeepsake63'
 import PROJECTKEEPSAKE64 from '@/components/ProjectKeepsake64'
 import PROJECTKEEPSAKE65 from '@/components/ProjectKeepsake65'
 import PROJECTKEEPSAKE66 from '@/components/ProjectKeepsake66'
 import PROJECTKEEPSAKE67 from '@/components/ProjectKeepsake67'
 import PROJECTKEEPSAKE68 from '@/components/ProjectKeepsake68'
 import PROJECTKEEPSAKE69 from '@/components/ProjectKeepsake69'
 import PROJECTKEEPSAKE70 from '@/components/ProjectKeepsake70'
 import PROJECTKEEPSAKE71 from '@/components/ProjectKeepsake71'
 import PROJECTKEEPSAKE72 from '@/components/ProjectKeepsake72'
 import PROJECTKEEPSAKE73 from '@/components/ProjectKeepsake73'
 import PROJECTKEEPSAKE74 from '@/components/ProjectKeepsake74'
 import PROJECTKEEPSAKE75 from '@/components/ProjectKeepsake75'
 import PROJECTKEEPSAKE76 from '@/components/ProjectKeepsake76'
 import PROJECTKEEPSAKE77 from '@/components/ProjectKeepsake77'
 import PROJECTKEEPSAKE78 from '@/components/ProjectKeepsake78'
 import PROJECTKEEPSAKE79 from '@/components/ProjectKeepsake79'
 import PROJECTKEEPSAKE80 from '@/components/ProjectKeepsake80'
 import PROJECTKEEPSAKE81 from '@/components/ProjectKeepsake81'
 import PROJECTKEEPSAKE82 from '@/components/ProjectKeepsake82'
 import PROJECTKEEPSAKE83 from '@/components/ProjectKeepsake83'
 import PROJECTKEEPSAKE84 from '@/components/ProjectKeepsake84'
 import PROJECTKEEPSAKE85 from '@/components/ProjectKeepsake85'
 import PROJECTKEEPSAKE86 from '@/components/ProjectKeepsake86'
 import PROJECTKEEPSAKE87 from '@/components/ProjectKeepsake87'
 import PROJECTKEEPSAKE88 from '@/components/ProjectKeepsake88'
 import PROJECTKEEPSAKE89 from '@/components/ProjectKeepsake89'
 import PROJECTKEEPSAKE90 from '@/components/ProjectKeepsake90'
 import PROJECTKEEPSAKE91 from '@/components/ProjectKeepsake91'
 import PROJECTKEEPSAKE92 from '@/components/ProjectKeepsake92'
 import PROJECTKEEPSAKE93 from '@/components/ProjectKeepsake93'
 import PROJECTKEEPSAKE94 from '@/components/ProjectKeepsake94'
 import PROJECTKEEPSAKE95 from '@/components/ProjectKeepsake95'
 import PROJECTKEEPSAKE96 from '@/components/ProjectKeepsake96'
 import PROJECTKEEPSAKE97 from '@/components/ProjectKeepsake97'
 import PROJECTKEEPSAKE98 from '@/components/ProjectKeepsake98'
 import PROJECTKEEPSAKE99 from '@/components/ProjectKeepsake99'
 import PROJECTKEEPSAKE100 from '@/components/ProjectKeepsake100'
 import PROJECTKEEPSAKE101 from '@/components/ProjectKeepsake101'
 import PROJECTKEEPSAKE102 from '@/components/ProjectKeepsake102'
 import PROJECTKEEPSAKE103 from '@/components/ProjectKeepsake103'
 import PROJECTKEEPSAKE104 from '@/components/ProjectKeepsake104'
 import PROJECTKEEPSAKE105 from '@/components/ProjectKeepsake105'
 import PROJECTKEEPSAKE106 from '@/components/ProjectKeepsake106'
 import PROJECTKEEPSAKE107 from '@/components/ProjectKeepsake107'
 import PROJECTKEEPSAKE108 from '@/components/ProjectKeepsake108'
 import PROJECTKEEPSAKE109 from '@/components/ProjectKeepsake109'
 import PROJECTKEEPSAKE110 from '@/components/ProjectKeepsake110'
 import PROJECTKEEPSAKE111 from '@/components/ProjectKeepsake111'
 import PROJECTKEEPSAKE112 from '@/components/ProjectKeepsake112'
 import PROJECTKEEPSAKE113 from '@/components/ProjectKeepsake113'
 import PROJECTKEEPSAKE114 from '@/components/ProjectKeepsake114'
 import PROJECTKEEPSAKE115 from '@/components/ProjectKeepsake115'
 import LOVE_2 from '@/components/love_2'
 import PROJECTKEEPSAKE116 from '@/components/ProjectKeepsake116'
 import PROJECTKEEPSAKE117 from '@/components/ProjectKeepsake117'
 import PROJECTKEEPSAKE118 from '@/components/ProjectKeepsake118'
 import COPYRIGHT from '@/components/Copyright'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/ProjectKeepsake59",
 			"name" : "ProjectKeepsake59",
 			"component" : PROJECTKEEPSAKE59
 		},
 		{
 			"path" : "/ProjectKeepsake60",
 			"name" : "ProjectKeepsake60",
 			"component" : PROJECTKEEPSAKE60
 		},
 		{
 			"path" : "/ProjectKeepsake61",
 			"name" : "ProjectKeepsake61",
 			"component" : PROJECTKEEPSAKE61
 		},
 		{
 			"path" : "/ProjectKeepsake62",
 			"name" : "ProjectKeepsake62",
 			"component" : PROJECTKEEPSAKE62
 		},
 		{
 			"path" : "/ProjectKeepsake63",
 			"name" : "ProjectKeepsake63",
 			"component" : PROJECTKEEPSAKE63
 		},
 		{
 			"path" : "/ProjectKeepsake64",
 			"name" : "ProjectKeepsake64",
 			"component" : PROJECTKEEPSAKE64
 		},
 		{
 			"path" : "/ProjectKeepsake65",
 			"name" : "ProjectKeepsake65",
 			"component" : PROJECTKEEPSAKE65
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js